import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";

import { colors } from "../../styles/colors";
import { FormInputRadioProps } from "./FormInputProps";
import fontWeight from "../../styles/mui/fontWeight";
import { DropdownOptionKeys } from "../../constants/FormComponents";
import { RadioFormHelperText, RadioFormLabelSize } from "./styles/style";

export const FormInputRadio: React.FC<FormInputRadioProps> = ({
  control,
  label,
  name,
  options,
  onInputChange,
  helper,
}) => (
  <FormControl component="fieldset">
    <FormLabel>
      <Typography
        variant="subtitle2"
        fontWeight={fontWeight.Weight[3]}
        color={colors.fonts[2]}
        fontSize={RadioFormLabelSize}
      >
        {label}
      </Typography>
      {helper?.required && (
        <Typography
          variant="h3"
          fontWeight={fontWeight.Weight[3]}
          color={colors.red[100]}
          fontSize={"0.85rem"}
          pl={"0.4rem"}
        >
          *
        </Typography>
      )}
    </FormLabel>
    <Controller
      name={name}
      control={control}
      rules={helper}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <RadioGroup
            row={true}
            value={value || null}
            onChange={(event) => {
              if (onInputChange) {
                onInputChange(event);
              }
              onChange(event);
            }}
          >
            {options.map((singleOption: DropdownOptionKeys) => (
              <FormControlLabel
                key={singleOption.value}
                value={singleOption.value}
                label={
                  <Typography
                    variant="subtitle1"
                    fontWeight="600"
                    color={colors.black[2]}
                    fontSize={RadioFormLabelSize}
                  >
                    {singleOption.label}
                  </Typography>
                }
                control={<Radio />}
              />
            ))}
          </RadioGroup>
          {error !== undefined && (
            <FormHelperText sx={RadioFormHelperText}>
              {error ? error.message : ""}
            </FormHelperText>
          )}
        </>
      )}
    />
  </FormControl>
);
